
import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { UserMembershipTypeDto } from '../../../models/user-membership/dto/user-membership.dto';

export const GET_USER_MEMBERSHIP_TYPES_QUERY_KEY = (organizationId: string) => [organizationId, 'membershipTypes']
export const useGetUserMembershipTypes = (organizationId: string) => {
    const apiClient = useApiClient();
    return useQuery({
        enabled: Boolean(organizationId),
        queryKey: GET_USER_MEMBERSHIP_TYPES_QUERY_KEY(organizationId),
        queryFn: async () => {
            const response = await apiClient.fetchApi<UserMembershipTypeDto[], {}>({ method: 'GET', endpoint: `organizations/${organizationId}/membershipTypes` });
            return response
        }
    });
};